module.exports = __webpack_public_path__ + "static/img/mongoDb.b1847af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/mongoDb.svg
// module id = ZnHJ
// module chunks = 1